import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Grid,
  Bag,
  People,
  ChevronDown,
  ChevronUp,
  Layers,
  BoxArrowLeft,
  Boxes,
  Wallet2,
  FileEarmarkText,
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import CONFIG from "../../config";
import { useDispatch, useSelector } from "react-redux";
import { authActions, store } from "../../store";
import { logout } from "../../services/authServices";
import { notify } from "../Common/Alerts";
import Utils from "../../utils";
import { BarChart, Heart } from "lucide-react";

const AdminSidebar = ({ isSidebarOpen, setStoreOwnerCart }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let auth = useSelector((x) => x.auth.value);

  const [openSubmenu, setOpenSubmenu] = useState({ Store: true });
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isRouteActive = (paths) => {
    return paths.some((path) => location.pathname.startsWith(path));
  };
  const [isLoading, setIsLoading] = useState(false);

  const menuItems = [
    {
      name: t("dashboard"),
      icon: <Grid size={18} />,
      path: "/dashboard",
      activePaths: ["/dashboard", "/pending-order", "/order-store-owner"],
    },

    ...(Number(auth?.user?.role_id) !== Number(CONFIG.ROLE_CUSTOMER)
      ? [
          {
            name: t("store"),
            icon: <People size={18} />,
            submenu: [
              {
                name: t("storeOwner"),
                path: "/owner-store",
                activePaths: [
                  "/owner-store",
                  "/owner-store-add",
                  "/owner-store-update",
                ],
                icon: <People size={18} />,
              },
              {
                name: t("store"),
                path: "/store",
                activePaths: ["/store", "/add-store", "/update-store"],
                icon: <People size={18} />,
              },
            ],
          },
          {
            name: t("customers"),
            icon: <People size={18} />,
            path: "/customers",
            activePaths: ["/customers"],
          },
        ]
      : []),

    ...(Number(auth.user.role_id) === CONFIG.ROLE_OWNER
      ? [
          {
            name: t("store"),
            icon: <People size={18} />,
            path: "/store",
            activePaths: ["/store", "/add-store", "/update-store"],
          },
          {
            name: t("order"),
            icon: <People />,
            path: "/all-store-owner-order-list",
            activePaths: [
              "/all-store-owner-order-list",
              "/all-store-owner-order-details",
            ],
          },
        ]
      : []),
    ...(Number(auth?.user?.role_id) !== Number(CONFIG.ROLE_CUSTOMER)
      ? [
          {
            name: t("category"),
            icon: <Layers size={18} />,
            path: "/category",
          },
          { name: t("units"), icon: <Layers size={18} />, path: "/units" },
          // {
          //   name: t("customers"),
          //   icon: <People size={18} />,
          //   path: "/customers",
          // },
          {
            name: t("products"),
            icon: <People size={18} />,
            path: "/products",
            activePaths: ["/products", "/products-add", "/products-update"],
          },
        ]
      : []),

    ...(Number(auth.user.role_id) === CONFIG.ROLE_OWNER
      ? [
          // {
          //   name: t("vendor"),
          //   icon: <People size={18} />,
          //   path: "/vendor",
          //   activePaths: ["/vendor", "/vendor-add"],
          // },
           {
            name: t("customers"),
            icon: <People size={18} />,
            path: "/customers-store",
            activePaths: ["/customers-store", "/customers-add"],
          },
          {
            name: t("wallet"),
            icon: <Wallet2 size={18} />,
            path: "/wallet",
            activePaths: ["/wallet"],
          },
          {
            name: t("favouriteProducts"),
            icon: <Heart size={18} />,
            path: "/fav-product",
            activePaths: ["/fav-product"],
          },

          {
            name: t("productChart"),
            icon: <BarChart size={18} />,
            path: "/product-chart",
            activePaths: ["/product-chart"],
          },

          {
            name: t("report"),
            icon: <FileEarmarkText size={18} />,
            path: "/customer-report",
            activePaths: ["/customer-report"],
          },

          // {
          //   name: t("stoctEntry"),
          //   icon: <BarChart size={18} />,
          //   path: "/stock-entry",
          //   activePaths: ["/stock-entry"],
          // },
        ]
      : []),

    ...(Number(auth.user.role_id) === CONFIG.ROLE_CUSTOMER
      ? [
          {
            name: t("store"),
            icon: <People size={18} />,
            path: "/customer-store",
            activePaths: ["/customer-store", "/wallet-store-details"],
          },
          {
            name: t("order"),
            icon: <Boxes size={18} />,
            path: "/order",
            activePaths: ["/order", "/order/details"],
          },
        ]
      : []),
  ];

  const filteredMenuItems =
    Number(auth.user.role_id) === CONFIG.ROLE_OWNER
      ? menuItems.filter((item) =>
          [
            "/dashboard",
            "/store",
            "/category",
            // "/customers",
            "/products",
            "/all-store-owner-order-list",
            "/wallet",
            "/product-chart",
            "/customer-report",
            "/fav-product",
            // "/vendor",
            // "/stock-entry",
            "/customers-store"
          ].includes(item.path),
        )
      : menuItems;

  const handleSubmenuToggle = (name) => {
    setOpenSubmenu((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  useEffect(() => {
    menuItems.forEach((item) => {
      if (item.submenu) {
        const isAnyChildActive = item.submenu.some((sub) =>
          isRouteActive(sub.activePaths || [sub.path]),
        );

        if (isAnyChildActive) {
          setOpenSubmenu((prev) => ({
            ...prev,
            [item.name]: true,
          }));
        }
      }
    });
  }, [location.pathname]);
  let roleId = Number(auth?.user?.role_id);

  const onLogout = (e) => {
    e.preventDefault();

    logout()
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        store.dispatch(authActions.logout());

        localStorage.removeItem("hasVisited");
        localStorage.removeItem(CONFIG.login_data);
        localStorage.removeItem("auth");
        document.documentElement.classList.remove("dark");

        if (roleId === Number(CONFIG.ROLE_ADMIN)) {
          navigate("/secure/login");
        } else {
          navigate("/login");
        }
      })
      .catch((error) => {
        notify.error(Utils.getErrorMessage(error));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleMenuClick = (e, item) => {
    if (item.path === "/dashboard") {
      localStorage.removeItem("storeOwnerCart");
      setStoreOwnerCart([]);
    }
  };

  return (
    <aside
      className={`
    ${isSidebarOpen ? "w-72" : "w-0 lg:w-20"} 
    transition-all duration-300 ease-in-out
    h-screen sticky top-0 left-0 z-40  {/* Changed from 50 to 40 */}
    bg-brand-orange dark:bg-slate-900 
    flex flex-col overflow-hidden shadow-2xl
  `}
    >
      <div className="p-8 mb-2 flex items-center gap-3">
        <div className="bg-white/20 backdrop-blur-md p-2.5 rounded-xl text-white shadow-inner flex-shrink-0">
          <Bag size={24} />
        </div>
        {isSidebarOpen && (
          <span className="text-white font-black text-2xl tracking-tight animate-fade-in">
            {t("dukaanSetu")}
          </span>
        )}
      </div>

      <nav className="flex-1 px-4 space-y-1 overflow-y-auto no-scrollbar pb-10">
        {filteredMenuItems?.map((item, i) => {
          const isParentActive = item.submenu
            ? item.submenu.some((sub) =>
                isRouteActive(sub.activePaths || [sub.path]),
              )
            : isRouteActive(item.activePaths || [item.path]);

          return (
            <div key={i} className="space-y-1">
              {item.submenu ? (
                <>
                  <button
                    onClick={() => {
                      handleSubmenuToggle(item.name);
                    }}
                    className={`w-full flex items-center py-4 rounded-2xl font-bold transition-all duration-200 ${
                      isSidebarOpen ? "px-4" : "justify-center"
                    } ${
                      isParentActive
                        ? "bg-white/10 text-white"
                        : "text-white/80 hover:bg-white/10 hover:text-white"
                    }`}
                    title={item.name}
                  >
                    <span className="flex-shrink-0">{item.icon}</span>
                    {isSidebarOpen && (
                      <>
                        <span className="ml-3 text-[15px]">{item.name}</span>
                        <span className="ml-auto opacity-50">
                          {openSubmenu[item.name] ? (
                            <ChevronUp size={12} />
                          ) : (
                            <ChevronDown size={12} />
                          )}
                        </span>
                      </>
                    )}
                  </button>

                  {openSubmenu[item.name] && (
                    <div
                      className={`mt-1 space-y-1 animate-fade-down animate-duration-300 ${
                        isSidebarOpen ? "pl-4" : "flex flex-col items-center"
                      }`}
                    >
                      {item.submenu.map((sub, subIdx) => {
                        const isActive = isRouteActive(
                          sub.activePaths || [sub.path],
                        );

                        return (
                          <NavLink
                            key={subIdx}
                            to={sub.path}
                            className={`flex items-center py-3 rounded-2xl text-[13px] font-extrabold transition-all duration-300 ${
                              isSidebarOpen ? "px-6" : "justify-center"
                            } ${
                              isActive
                                ? "bg-white text-brand-orange shadow-xl translate-x-1"
                                : "text-white/70 hover:text-white hover:bg-white/5"
                            }`}
                            title={sub.name}
                          >
                            {isSidebarOpen ? (
                              <>
                                <span className="w-1.5 h-1.5 rounded-full bg-current mr-3 opacity-40"></span>
                                {sub.name}
                              </>
                            ) : (
                              <span>{sub.icon}</span>
                            )}
                          </NavLink>
                        );
                      })}
                    </div>
                  )}
                </>
              ) : (
                <NavLink
                  to={item.path}
                  onClick={(e) => handleMenuClick(e, item)}
                  className={`flex items-center py-4 rounded-2xl font-bold transition-all duration-300 ${
                    isSidebarOpen ? "px-4" : "justify-center"
                  } ${
                    isParentActive
                      ? "bg-white text-brand-orange shadow-xl"
                      : "text-white/80 hover:bg-white/10"
                  }`}
                  title={item.name}
                >
                  <span className="flex-shrink-0">{item.icon}</span>
                  {isSidebarOpen && (
                    <span className="ml-3 text-[15px]">{item.name}</span>
                  )}
                </NavLink>
              )}
            </div>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-white/10 bg-black/5 dark:bg-black/20">
        <button
          className="w-full flex items-center gap-3 px-4 py-4 text-white/80 font-black hover:text-white hover:bg-red-500/20 rounded-2xl transition-all uppercase text-[11px] tracking-widest"
          onClick={() => setShowLogoutModal(true)}
        >
          <BoxArrowLeft size={18} />
          {isSidebarOpen && <span>{t("logOutStore")}</span>}
        </button>
      </div>
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white dark:bg-[#161e2d] rounded-3xl p-6 w-[90%] max-w-sm shadow-2xl animate-fade-in">
            <h2 className="text-lg font-bold text-gray-800 dark:text-white mb-2">
              {t("confirmLogout")}
            </h2>

            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
              {t("confirmLogoutDescription")}{" "}
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="px-4 py-2 rounded-xl bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-200 font-semibold hover:bg-gray-200 transition"
              >
                {t("cancel")}
              </button>

              <button
                onClick={(e) => {
                  setShowLogoutModal(false);
                  onLogout(e);
                }}
                className="px-4 py-2 rounded-xl bg-red-500 text-white font-semibold hover:bg-red-600 transition"
              >
                {t("yesLogOut")}
              </button>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
};

export default AdminSidebar;
